import clsx from 'clsx'
import type { ReactNode } from 'react'
import { useNavigate } from 'react-router'

import { ArrowUpRightIcon } from '@/shared/icons'

import s from './KpiCard.module.css'
import { Skeleton } from './Skeleton'

interface KpiCardProps {
  label: ReactNode
  value?: ReactNode
  unit?: string
  /** Текст вместо значения, когда данных нет («Нет данных», «Нет актуальных данных»). */
  placeholder?: string
  sub?: ReactNode
  footnote?: ReactNode
  /** Маршрут, куда ведёт карточка. Если задан — карточка кликабельна. */
  to?: string
  loading?: boolean
  className?: string
  /** sm — компактная карточка для плотной сетки (меньше отступы и цифра). */
  size?: 'md' | 'sm'
}

export function KpiCard({
  label,
  value,
  unit,
  placeholder,
  sub,
  footnote,
  to,
  loading,
  className,
  size = 'md',
}: KpiCardProps) {
  const navigate = useNavigate()
  const Tag = to ? 'button' : 'div'

  return (
    <Tag
      className={clsx(s.card, to && s.link, size === 'sm' && s.sm, className)}
      onClick={to ? () => navigate(to) : undefined}
      type={to ? 'button' : undefined}
    >
      {to && (
        <span className={s.go}>
          <ArrowUpRightIcon size={12} />
        </span>
      )}
      <span className={s.label}>{label}</span>
      <span className={s.value}>
        {loading ? (
          <Skeleton width={size === 'sm' ? 56 : 72} height={size === 'sm' ? 26 : 30} />
        ) : placeholder ? (
          <span className={s.placeholder}>{placeholder}</span>
        ) : (
          value
        )}
        {!loading && !placeholder && unit && <small className={s.unit}>{unit}</small>}
      </span>
      {sub && <span className={s.sub}>{loading ? <Skeleton width={140} height={13} /> : sub}</span>}
      {footnote && <span className={s.footnote}>{footnote}</span>}
    </Tag>
  )
}
